import { getLanguage, localizedPath, setLanguage, t } from '../public/i18n.js';

export function RfSuiteHeader(): JSX.Element {
  const language = getLanguage();
  return <header className="suite-header">
    <div className="suite-header-primary">
      <a className="suite-brand" href="https://autosecurelogin.com/" aria-label="Auto Secure Login">
        <img className="suite-logo" src="/assets/asl-logo.svg" alt="" width="40" height="40" />
        <span className="suite-brand-copy"><strong>{t('Security & RF')}</strong><small>Auto Secure Login</small></span>
      </a>
      <div className="suite-utility"><a className="suite-platform" href="https://autosecurelogin.com/">{t('All ASL products')}</a>
        <div className="lang-toggle" role="group" aria-label={language === 'es' ? 'Idioma' : 'Language'}>
          {(['en','es'] as const).map(code => <button className="lang-btn" key={code} type="button" aria-label={code === 'es' ? 'Español' : 'English'} aria-pressed={language === code} onClick={() => setLanguage(code)}>{code.toUpperCase()}</button>)}
        </div>
      </div>
    </div>
    <nav className="suite-nav-shell" aria-label="ASL RF"><div className="suite-nav">
      <div className="suite-nav-group"><span className="suite-nav-label">{t('Tools')}</span>
        <a href="https://bandsight.autosecurelogin.com/">BandSight</a>
        <a href="https://signallab.autosecurelogin.com/">SignalLab</a>
        <a href={localizedPath('/monitoring.html')}>{t('Network Console')}</a>
      </div>
      <div className="suite-nav-group"><span className="suite-nav-label">{t('Reference')}</span>
        <a href="https://bandsight.autosecurelogin.com/hardware.html">{t('Hardware & setup')}</a>
        <a href="https://bandsight.autosecurelogin.com/bandplan.html">{t('Band reference')}</a>
        <a href={localizedPath('/help-center/index.html')}>{t('Help')}</a>
      </div>
    </div></nav>
  </header>;
}
